export function getUrl(param) {
    const url = 'https://corploans.a-bank.com.ua';
    return param ? `${url}?type=${param}` : url;
}
